export type FileType = 'xlsx' | 'csv' | 'xls' | 'xlsm' | 'ods' | 'txt';
export type mimeTypeMapping = {
  [key in FileType]: string;
};

export const MIME_TYPE_MAPPING: Record<FileType, string> = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  csv: 'text/csv',
  xls: 'application/vnd.ms-excel',
  xlsm: 'application/vnd.ms-excel.sheet.macroEnabled.12',
  ods: 'application/vnd.oasis.opendocument.spreadsheet',
  txt: 'text/plain',
};
